import * as React from "react";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import { Hostovani, GetHostovani as apiGetHostovani } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import View from "./detail-hostovani/View";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    hostovani?: Hostovani;
}

export interface DetailHostovaniDlouhodobeProps {
    backUrl?: string;
    backTitle?: string;
    hostovaniId: number;
    clenId: number;
}

type Props = State & DetailHostovaniDlouhodobeProps & ActionsExecutorPropsType;

const initialState: State = {
    loading: true,
    hasError: false,
}

class DetailHostovaniDlouhodobe extends React.PureComponent<Props> {

    load = () => {
        const { executeAction, updateState, hostovaniId } = this.props;
        const action = apiGetHostovani(hostovaniId)
            .onSuccess(d => {
                updateState({ loading: false, hostovani: d });
            })
            .onError(e => {
                const errMessage = e.errorData && e.errorData.notFound ? `Dlouhodobé hostování s ID ${hostovaniId} nebylo nalezeno.` : e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    setHostovani = (hostovani: Hostovani) => {
        this.props.updateState({ loading: false, hostovani: hostovani });
    }

    componentWillMount() {
        this.load();
    }

    render() {
        const { loading, hasError, error, hostovani, clenId } = this.props;

        return loading
            ? <Loading loading={loading} color="primary" />
            : hasError
                ? <Error>{error}</Error>
                : <View clenId={clenId} hostovani={hostovani} setHostovani={this.setHostovani} />;
    }
}

export default withActionsExecutor<DetailHostovaniDlouhodobeProps, State>(initialState, DetailHostovaniDlouhodobe);